// src/models/enums/UserStatusEnum.ts

/**
 * Lifecycle state of a user account.
 * Independent of the user's permanent role (see UserRoleEnum).
 *
 * - ACTIVE:           Account is in normal use.
 * - SUSPENDED:        Temporarily restricted by admin/mod for a fixed term.
 *                     Auto-lifted once suspensionEndDate passes (on the user's
 *                     next login, or by the hourly SuspensionExpiryScheduler).
 *                     A suspension with no end date stays until lifted by hand.
 * - BANNED:           Permanently restricted by admin.
 * - FROZEN_BY_USER:   User voluntarily paused their account. Auto-lifted on next login.
 * - DELETED_BY_USER:  User requested deletion. Grace period active.
 * - DELETED_BY_ADMIN: Account permanently removed by admin.
 * - INACTIVE:         Auto-set after extended period of no logins.
 */
export enum UserStatusEnum {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  BANNED = "BANNED",
  FROZEN_BY_USER = "FROZEN_BY_USER",
  DELETED_BY_USER = "DELETED_BY_USER",
  DELETED_BY_ADMIN = "DELETED_BY_ADMIN",
  INACTIVE = "INACTIVE",
}